export const getEventUrl = (event) => {
    let now = Math.round(Date.now() / 1000);
    if (!event.start)
        return '/cs/aukce/' + event.id;
    // console.log("EVENT url", event.start, now, event.end);
    if (now < event.start) {
        return '/cs/aukce/' + event.id;
    }
    else {
        if (now < event.end) {
            return '/cs/aukce/' + event.id;
        }
        else {
            return '/cs/aukce/' + event.id;
        }
    }
};
export const getEventEditUrl = (event) => {
    return `/cs/proces/editovat-aukci/${event.id}`;
};
export var EEventTimeState;
(function (EEventTimeState) {
    EEventTimeState[EEventTimeState["ToBe"] = 0] = "ToBe";
    EEventTimeState[EEventTimeState["Open"] = 1] = "Open";
    EEventTimeState[EEventTimeState["Closed"] = 2] = "Closed";
})(EEventTimeState || (EEventTimeState = {}));
export const getEventState = (event) => {
    let now = Math.round(Date.now() / 1000);
    // if(!event.start) return '/cs/seznam/nejblizsi-aukce';
    if (now < event.start || !event.start) {
        return { listUrl: '/cs/seznam/nejblizsi-aukce', title: "Nejbližší aukce", timeState: EEventTimeState.ToBe };
    }
    else {
        if (now > event.end) {
            return { listUrl: '/cs/seznam/ukoncene-aukce', title: "Ukončené aukce", timeState: EEventTimeState.Closed };
        }
        else {
            return { listUrl: '/cs/seznam/probihajici-aukce', title: "Probíhající aukce", timeState: EEventTimeState.Open };
        }
    }
};
